/** North American phone number countries supported for Twilio local SMS numbers. */
export const NA_PHONE_COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
];

export function normalizeNaPhoneCountry(country) {
  return country === 'CA' ? 'CA' : 'US';
}
